module.exports = __webpack_public_path__ + "assets/customer-service-5f78399eb2ff543363c863661de8e2d1.svg";